function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "contacts-import",
  transform: "translate(-869.000000, -388.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "import",
  transform: "translate(803.000000, 184.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "platform-buttons",
  transform: "translate(50.000000, 82.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "button-gmail",
  transform: "translate(0.000000, 101.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon-gmail",
  transform: "translate(16.000000, 21.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#ECEFF1",
  x: 6,
  y: 0,
  width: 29,
  height: 29
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#CFD8DC",
  points: "21 17.3500107 36 29 36 6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.25,0 L35,0 L20,11.4501667 L5,0 L3.75,0 C1.68,0 0,1.624 0,3.625 L0,25.375 C0,27.376 1.68,29 3.75,29 L5,29 L5,6.3945 L20,17.5474167 L35,6.39208333 L35,29 L36.25,29 C38.32,29 40,27.376 40,25.375 L40,3.625 C40,1.624 38.32,0 36.25,0 Z",
  id: "Path",
  fill: "#F44336"
})))))));

function SvgIconGmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "29px",
    viewBox: "0 0 40 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-gmail") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGmail);
export default __webpack_public_path__ + "static/media/icon-gmail.7fcd7209.svg";
export { ForwardRef as ReactComponent };